import React from 'react';
import PropTypes from 'prop-types';
import styles from '../DashboardPage/DashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { TDDS_TRADE_RATIO_SUMMARY, TDDS_SHARE_RATIO_SUMMARY, TDDS_NOTIONAL_RATIO_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const TDDS_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_TRADE_RATIO_SUMMARY);
const TDDS_SHARE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_SHARE_RATIO_SUMMARY);
const TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(TDDS_NOTIONAL_RATIO_SUMMARY);

class DashboardTddsGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = this.props.pauseRealTimeData;
    return (
      <div className={styles.tddsTables} >
        <LiveDataGrid
          identifier={TDDS_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_TRADE_RATIO_SUMMARY_CONFIG.header}
          ws={TDDS_TRADE_RATIO_SUMMARY_CONFIG.ws}
          api={TDDS_TRADE_RATIO_SUMMARY_CONFIG.api}
          downloadApi={TDDS_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={TDDS_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={TDDS_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={TDDS_SHARE_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_SHARE_RATIO_SUMMARY_CONFIG.header}
          ws={TDDS_SHARE_RATIO_SUMMARY_CONFIG.ws}
          api={TDDS_SHARE_RATIO_SUMMARY_CONFIG.api}
          downloadApi={TDDS_SHARE_RATIO_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={TDDS_SHARE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={TDDS_SHARE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_SHARE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_SHARE_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.identifier}
          header={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.header}
          ws={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.ws}
          api={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.api}
          downloadApi={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataCustomColumns={TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG.summaryGroupDataCustomColumns}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />
      </div>
    );
  }
}

export default DashboardTddsGrids;
export const MemoizedDashboardTddsGrids = React.memo(DashboardTddsGrids);

DashboardTddsGrids.propTypes = {
  pauseRealTimeData: PropTypes.bool
};
